import { render } from "./resouce_download.vue?vue&type=template&id=3be7a0d6&scoped=true"
import script from "./resouce_download.vue?vue&type=script&lang=js"
export * from "./resouce_download.vue?vue&type=script&lang=js"

import "./resouce_download.vue?vue&type=style&index=0&id=3be7a0d6&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be7a0d6"]])

export default __exports__